import { useMemo } from "react"

import _ from "lodash"

import {
    Layer,
    MapStyles,
    ROAD_ROADSIDE_LAYER,
    ROAD_ROADSIDE_SOURCE,
    useMapStateContext,
    useOrderingLayers,
} from "@l2r-front/l2r-map"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useTheme } from "@l2r-front/l2r-ui"

import { getRoadRoadsideLayerStyle } from "../../utils/getRoadsideConfig"

import { RoadRoadsideHomogenousZonesSource } from "../RoadRoadsideHomogenousZonesSource"

export function RoadRoadsideHomogenousZonesLayer(props) {
    const { road } = props

    const { selectedLinearLocations } = useNetworksStateContext()
    const { getCurrentMapStyle } = useMapStateContext()
    const theme = useTheme()

    const roadRoadsideLayerConfig = useMemo(() => {
        const selectedRoad = selectedLinearLocations?.[0].road
        const currentMapStyle = getCurrentMapStyle()
        const referentialColor = currentMapStyle === MapStyles.plan ? theme.palette.map.darkReferential
            : theme.palette.map.lightReferential
        return getRoadRoadsideLayerStyle(referentialColor, theme, selectedRoad)
    }, [getCurrentMapStyle, theme, selectedLinearLocations])

    useOrderingLayers([ROAD_ROADSIDE_LAYER])

    return (
        <RoadRoadsideHomogenousZonesSource
            id={ROAD_ROADSIDE_SOURCE}
            type="geojson"
            tolerance={.001}
            road={road}
        >
            <Layer
                id={ROAD_ROADSIDE_LAYER}
                {...roadRoadsideLayerConfig}
            />
        </RoadRoadsideHomogenousZonesSource>
    )
}
